import { environment } from '../../environments/environment';

const alliesAPI = environment.alliesAPI;
export const API_PATH = environment.API_PATH;
export const SUBSCRIPTION_KEY = environment.subscriptionKey;
export const ADDRESSY_API_KEY = environment.addressyAPIKey;
export const NEW_BOOKING_AMEND_URL = environment.amendBookingURL;
export const FLIGHT_STATS = 'Web/api/Flight/GetFlightStatus';
export const GET_COVERAGE_MAP = 'Web/api/Price/GetZonePrice';
export const GET_PROMO_ID = 'Web/api/Promotion/GetPromotionById';
export const GET_FLIGHT_DETAILS = 'Web/api/Flight/GetFlightDetails';
export const GET_FLIGHT_CONNECTIONS = 'Web/api/Flight/GetFlightConnections';
export const GET_ALL_AIRPORTS = 'Web/api/Location/GetAllAirports';
export const GET_ALL_POSTCODES = 'Web/api/Price/GetAllPostcodes';
export const VALIDATE_POSTCODES = 'Web/api/Price/ValidatePostCode';
export const GET_BLOCKED_POSTCODES = 'Web/api/Location/GetBlockedLocations';
export const GET_LOCATION = 'Web/api/Location/GetLocationByLocationProvider';
export const GET_GOOGLE_LOCATION = 'Web/api/Location/GetGoogleLocation';
export const SAVE_GOOGLE_LOCATION = 'Web/api/Location/SaveGoogleLocation';
export const VERIFY_USER = 'Web/api/User/VerifyCustomer';
export const VALIDATE_USER = 'Web/api/User/ValidateCustomer';
export const SEND_VERIFY_SMS = 'Web/api/SMS/SendVerifyUserSMS';
export const SEND_MAGIC_LINK = 'Web/api/Communication/SendUserLoginEmail';
export const VALIDATE_SMS_CODE = 'Web/api/User/ValidateSMSCode';
export const TOKEN = 'Web/token';
export const LOGIN = 'Web/api/User/GetCurrentUsersLocation';
export const REGISTER = 'Web/api/User/AddNewUser';
export const GENERATE_TIMESLOTS = 'Web/api/Booking/GenerateValidTimeSlots';
export const RESERVE_TIMESLOTS = 'Web/api/Timeslot/ReserveATimeslot';
export const ADD_BOOKING = 'Web/api/Booking/AddBooking';
export const PRICING = 'Web/api/Price/CalculateBookingPrice';
export const STORE_JSON_DATA = 'Web/api/DataStorage/StoreOrUpdateJsonData';
export const GET_JSON_DATA = 'Web/api/DataStorage/GetJsonData/';
export const SEND_RESET_PASSWORD = 'Web/api/User/SendResetPasswordLink';
export const GET_TOKEN_DATA = 'Web/api/System/GetTokenData';
export const RESET_PASSWORD = 'Web/api/User/ResetPassword';
export const SET_PASSWORD = 'Web/api/User/SetPassword';
export const UPDATE_USER_DETAILS = 'Web/api/User/UpdateUser';
export const GET_DESTINATION_AIRPORTS = 'Web/api/Location/GetAirportLocationSystemObject';
export const GET_RESIDENTIAL_LOCATIONS = 'https://ws.postcoder.com/pcw/' + alliesAPI + '/autocomplete/v2/uk/';
export const GET_TEXT_FREE_ADDRESSES = 'https://api.addressy.com/Capture/Interactive/Find/v1.10/json3.ws';
export const MAKE_PAYMENT = 'Web/api/Payment/MakePayment';
export const GET_APPLE_PAY_SESSION = 'Payment/api/Payment/ApplePaySession';
export const PROMO_VALID = 'Web/api/Promotion/IsPromoValid';
export const GET_LEAD_IN_SESSION = 'Web/api/Session/GetStoredLeadinSession';
export const COMPLETE_BOOKING = 'Web/api/Booking/GetBookingSummaries';
export const INCOMPLETE_BOOKING = 'Web/api/Booking/GetIncompleteBookings';
export const BOOKING_DETAILS_LITE = 'Web/api/Booking/BookingDetailsLite';
export const GET_IMAGE_URL = 'Web/api/Image/getImageUrlLite';
export const DELETE_INCOMPLETE = 'Web/api/Booking/DeletePartialBooking';
export const DELETE_COMPLETE_BOOKING = 'Web/api/Booking/CancelBooking';
export const GET_COMPLETED_BOOKING = 'Web/api/Booking/GetCompleteBookingRequest';
export const AMEND_BOOKING = 'Web/api/Booking/AmendBooking';
export const RESEND_REGISTER_EMAIL = 'Web/api/Communication/SendUserEmail';
export const SEND_ONE_TIME_LOGIN_CODE = 'Web/api/SMS/SendOneTimeLoginCode';
// ValidateSMSCode
export const RESEND_COMMS = 'Web/api/Communication/SendComms';
export const GENERATE_BOOKING_REFERENCE = 'Web/api/Booking/GenerateBookingReference';
export const GET_BOOKING_DETAILS = 'Web/api/Booking/GetBookingDetails';
export const VALIDATE_PHONE_NUMBER = 'Web/api/ConnectedAPIs/ValidatePhoneNumber';
export const GET_USER_BY_ID = 'Web/api/User/GetUserById';
export const GET_USERS = 'Web/api/User/GetUsers';
export const ADD_BOOKING_NOTE = 'Web/api/Communication/AddBookingNote';
export const ADD_AIRLINE_BOOKING_REFERENCE = 'Web/api/Airline/AddAirlineBookingReference';
export const DELETE_SAVED_CARD = 'Payment/api/Payment/DisableSavedCard';
export const SYSTEM_OBJECTS = 'Web/api/System/GetSystemObjects';
export const GET_COPY_DATA = 'Web/api/Content/GetBookingContent';
export const ADD_QUESTION_ANSWER = 'Web/api/Communication/StoreCustomerQuestionAnswerResponse';
export const GET_QUESTION_ANSWER = 'Web/api/Communication/RetrieveCustomerQuestionAnswers';
export const ADD_IMAGE = 'Web/api/Image/AddImage';
export const AMEND_DELIVERY_DATETIME = 'Web/api/AdminBooking/AmendDeliveryDateTime';
export const AMEND_COLLECTION_DATETIME = 'Web/api/AdminBooking/AmendCollectionDateTime';
export const GET_DATE_TIME = 'Web/api/System/CurrentUKDateTime';
export const TIMESLOTS = 'Web/api/ProductTier/GetProductTierTimeSlot';
export const TIMESLOT_AVAILABILITY = 'Web/api/ProductTier/GetProductTierTimeSlotAvailability';
export const GET_RETURN_SESSION = 'Web/api/Session/GetStoredReturnLeadinSession';
export const EXCESS_BAGGAGE_PAYMENT = 'Payment/api/Payment/PayForExcessBag';
export const VALIDATE_GEO_COORDS = 'web/api/GeoCoord/ValidateGeoCoord';
export const GET_POST_OFFICE = 'web/api/Location/GetPostOfficeDetails';
export const CHECK_FLY_BACK_ELIGIBILITY = 'Web/api/Product/GetFlyBackEligibility';
export const STORE_LEAD_IN = 'Web/api/Session/StoreLeadinSession';
// export const EXCESS_BAGGAGE_PAYMENT = 'api/Payment/MakeExcessBaggagePayment';
export const SET_MARKETING_FLAG = 'Web/api/Marketing/SetMarketingFlag';
export const GET_USER_IP = 'https://api.ipify.org?format=json';
export const SET_PNR = 'Web/api/DCS/UpdatePNR';
export const SET_ABANDONMENT = 'Web/api/ConnectedAPIs/ZapierMCConnect';
// Miles and More
export const GET_MAM_ACCESS_TOKEN = 'Payment/api/Credits/GetMilesAccess';
export const GET_MILES_RANGE = 'Payment/api/Credits/GetMilesRange';
export const PAY_BY_MILES = 'Payment/api/Credits/PayByMiles';
export const AMEND_MCHECKOUT_STATUS = 'Payment/api/Credits/AmendMcheckoutStatus';
export const MILES_REFUND = 'Payment/api/Credits/RefundMiles';
export const MILES_LOGIN_URL = environment.milesLoginURL;
// static data files
export const GET_STATIC_COPY_DATA = './static-api-data/copy-generic.json';
export const GET_AIRPORT_COPY_DATA = './static-api-data/airports.json';
export const TEST_FLIGHT_DATA = './static-api-data/test-flight-data.json';
export const GET_ERROR_COPY_DATA = './static-api-data/error-messages.json';
export const GET_PASSENGER_RULES_COPY_DATA = 'airlineconfiguration/api/Airline/GetDynamicContent';
// zone sent with GetProductTierTimeSlot for GBTA bookings (location step is skipped)
export const GBTA_ZONE_ID = '0D5727AB-FFEC-44E9-90EA-3B5ABF8C4BA3';
// Strapi paths
export const STRAPY_BOOKING_TRANSLATION = 'Mobile/api/Content/GetDataFromStrapi?strapiDataType=AllTranslations&';

// Partial html paths
export const FLIGHT_REQUEST_ABC = './flight-request.component.html';

// react components
export const REACT_QUOTE_FORM = environment.reactQuoteForm;
export const BOOKINGPOD_GLOBAL_FNS = environment.bookingPodGlobalFns;
export const PORTR_CRM_POPUPS = environment.portrCRMPopups;
export const MOBILE_API_KEY = environment.mobileAPIKey;
// A/B Testing slots
export const SLOT_NUMBER = environment.slotNumber;
export const SLOT_VERSION = environment.slotVersion;

export const CURRENCY_CODES = {
  '£': {
    code: 'GBP', symbol: '£'
  },
  '$': {
    code: 'USD', symbol: '$'
  },
  'CHF': {
    code: 'CHF', symbol: 'CHF '
  },
  '€': {
    code: 'EUR', symbol: '€'
  },
  'EUR': {
    code: 'EUR', symbol: 'EUR'
  }
}

export enum ISO_CURRENCY_CODES {
  GBP = 826,
  USD = 840,
  JOD = 400,
  CHF = 756,
  EUR = 978
}

export enum PLAN_TYPES {
  Fixed,
  SemiFlex,
  FullyFlex
}

export const PLAN_TYPES_MAPPING = {
  Fixed: 'Fixed',
  SemiFlex: 'Semi Flex',
  FullyFlex: 'Fully Flex'
}
// partner airlines
export const ABC_PARTNERS = [
  {
    code: 'BA',
    name: 'British Airways',
    codeName: 'BRITISHAIRWAYS',
    doorstepDeliveryDestinations: ['DFW']
  },
  {
    code: 'AA',
    name: 'American Airlines',
    codeName: 'AMERICANAIRLINES',
    doorstepDeliveryDestinations: ['DFW']
  },
  {
    code: 'U2',
    name: 'EasyJet',
    codeName: 'EASYJET',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'AY',
    name: 'Finnair',
    codeName: 'FINNAIR',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'VS',
    name: 'Virgin Atlantic',
    codeName: 'VIRGINATLANTIC',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'CX',
    name: 'Cathay Pacific',
    codeName: 'CATHAYPACIFIC',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'QF',
    name: 'Qantas',
    codeName: 'QANTAS',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'BY',
    name: 'TUI',
    codeName: 'TUI',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'LX',
    name: 'Swiss',
    codeName: 'SWISS',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'DE',
    name: 'Condor',
    codeName: 'CONDOR',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'SQ',
    name: 'Singapore Airlines',
    codeName: 'SINGAPOREAIRLINES',
    doorstepDeliveryDestinations: []
  },
  {
    code: "EI",
    name: "Aer Lingus",
    codeName: 'AERLINGUS',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'EDW',
    name: 'Edelweiss Air',
    codeName: 'EDELWEISSAIR',
    doorstepDeliveryDestinations: []
  },
  {
    code: "EK",
    name: "Emirates",
    codeName: 'EMIRATES',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'KL',
    name: 'KLM Royal Dutch Airline',
    codeName: 'KLMROYALDUTCHAIRLINE',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'AF',
    name: 'Air France',
    codeName: 'AIRFRANCE',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'OS',
    name: 'Austrian',
    codeName: 'AUSTRIAN',
    doorstepDeliveryDestinations: []
  },
  // new airlines
  {
    code: 'A3',
    name: 'Aegean Airlines',
    codeName: 'AEGEANAIRLINES',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'AC',
    name: 'Air Canada',
    codeName: 'AIRCANADA',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'AZ',
    name: 'ITA Airways',
    codeName: 'ITAAIRWAYS',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'DL',
    name: 'Delta Airlines',
    codeName: 'DELTAAIRLINES',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'LH',
    name: 'Lufthansa',
    codeName: 'LUFTHANSA',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'SN',
    name: 'Brussels Airlines',
    codeName: 'BRUSSELSAIRLINES',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'TG',
    name: 'Thai Airways International',
    codeName: 'THAIAIRWAYSINTERNATIONAL',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'TK',
    name: 'Turkish Airlines',
    codeName: 'TURKISHAIRLINES',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'TP',
    name: 'Tap Air Portugal',
    codeName: 'TAPAIRPORTUGAL',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'UA',
    name: 'United Airlines',
    codeName: 'UNITEDAIRLINES',
    doorstepDeliveryDestinations: []
  },
  {
    code: 'UX',
    name: 'Air Europa',
    codeName: 'AIREUROPA',
    doorstepDeliveryDestinations: []
  },
  {
    code: "4Y",
    name: "Discover Airlines",
    codeName: 'DISCOVERAIRLINES',
    doorstepDeliveryDestinations: []
  },
];
// booking status codes
export const BookingListstatus = {
  1: {
    'status': 'Scheduled',
    'background': '#00005A0D',
    'borderColor': 'transparent',
    'color': 'transparent',
    'iconClassName': '',
    'className': 'scheduled',
    'message': '',
    'link': '',
    'isIssue': false,
    'actionCTA': 'Track'
  },
  2: {
    'status': 'Scheduled',
    'background': '#F9F6DE',
    'borderColor': '#F1ECBF',
    'color': '#807100',
    'iconClassName': 'icon-alert',
    'className': 'scheduled-warning',
    'message': 'Please sign your Customs Declaration. Failure to do so will result in booking cancellation. Learn more by clicking here.',
    'link': 'https://support.airportr.com/hc/en-us/articles/34694091466513-Customs-Information-and-Charges',
    'isIssue': true,
    'actionCTA': 'Sign Customs Declaration'
  },
  '4a': {
    'status': 'Scheduled',
    'background': '#F9F6DE',
    'borderColor': '#F1ECBF',
    'color': '#807100',
    'iconClassName': 'icon-alert',
    'className': 'scheduled-warning',
    'message': 'Please complete your pre-check-in declarations before bag collection or drop-off. Your booking may be canceled if this step is not completed.',
    'link': 'track',
    'isIssue': true,
    'actionCTA': 'Complete Pre-Acceptance'
  },
  4: {
    'status': 'Scheduled',
    'background': '#F9F6DE',
    'borderColor': '#F1ECBF',
    'color': '#807100',
    'iconClassName': 'icon-alert',
    'className': 'scheduled-warning',
    'message': 'Please complete your pre-check-in declarations before bag collection or drop-off. This will save time when we accept your bags.',
    'link': 'track',
    'isIssue': true,
    'actionCTA': 'Complete Pre-Acceptance'
  },
  3: {
    'status': 'Scheduled',
    'background': '#F9F6DE',
    'borderColor': '#F1ECBF',
    'color': '#807100',
    'iconClassName': 'icon-alert',
    'className': 'scheduled-warning',
    'message': 'Please upload your IATA Tag of your checked in luggage. Learn more by clicking here.',
    'link': 'https://support.airportr.com/hc/en-us/articles/34694394425617-Uploading-Bag-Tags',
    'isIssue': true,
    'actionCTA': 'Upload IATA Tag'
  },
  'ccdBaggage': {
    'status': 'Scheduled',
    'background': '#F9F6DE',
    'borderColor': '#F1ECBF',
    'color': '#807100',
    'iconClassName': 'icon-alert',
    'className': 'scheduled-warning',
    'message': 'Please upload a photo of your bag(s). Learn more by clicking here.',
    'link': 'uploadBagImage',
    'isIssue': true,
    'actionCTA': 'Upload Bag Images'
  },
  10: {
    'status': 'On Time',
    'background': '#00005A0D',
    'borderColor': 'transparent',
    'color': 'transparent',
    'iconClassName': '',
    'className': 'on-time',
    'message': '',
    'link': '',
    'isIssue': false,
    'actionCTA': 'Track'
  },
  11: {
    'status': 'Running Late',
    'background': '#F9F6DE',
    'borderColor': 'transparent',
    'color': 'transparent',
    'iconClassName': '',
    'className': 'running-late',
    'message': '',
    'link': '',
    'isIssue': false,
    'actionCTA': 'Track'
  },
  12: {
    'status': 'Arriving Early',
    'background': '#D9F8DE',
    'borderColor': 'transparent',
    'color': 'transparent',
    'iconClassName': '',
    'className': 'arriving-early',
    'message': '',
    'link': '',
    'isIssue': false,
    'actionCTA': 'Track'
  },
  20: {
    'status': 'In Progress',
    'background': '#00005A0D',
    'borderColor': 'transparent',
    'color': 'transparent',
    'iconClassName': '',
    'className': 'in-progress',
    'message': '',
    'link': '',
    'isIssue': false,
    'actionCTA': 'Track'
  },
  21: {
    'status': 'In Progress',
    'background': '#FAE1E1',
    'borderColor': '#F7CFCF',
    'color': '#C81313',
    'iconClassName': 'icon-alert',
    'className': 'in-progress-warning',
    'message': 'Please pay your excess charges to avoid booking cancellation. Learn more by clicking here.',
    'link': 'https://support.airportr.com/hc/en-us/articles/4403877219089-What-is-an-airline-Excess-Baggage-charge',
    'isIssue': true,
    'actionCTA': 'Pay Excess Charges'
  },
  22: {
    'status': 'In Progress',
    'background': '#F9F6DE',
    'borderColor': '#F1ECBF',
    'color': '#807100',
    'iconClassName': 'icon-alert',
    'className': 'in-progress-warning',
    'message': '1 or more passengers has not checked in. Please check in to avoid booking cancellation. Learn more by clicking here.',
    'link': 'https://support.airportr.com/hc/en-us/articles/24074472921489-My-collection-is-scheduled-before-check-in-opens',
    'isIssue': true,
    'actionCTA': 'Track'
  },
  23: {
    'status': 'In Progress',
    'background': '#F9F6DE',
    'borderColor': '#F1ECBF',
    'color': '#807100',
    'iconClassName': 'icon-alert',
    'className': 'in-progress-warning',
    'message': 'One or more of your bags is reported missing. Please click here to view your options. Learn more by clicking here.',
    'link': 'https://support.airportr.com/hc/en-us/articles/4403885089169-Arrivals-What-if-my-bag-isn-t-on-the-baggage-reclaim-at-my-destination',
    'isIssue': true,
    'actionCTA': 'Track'
  },
  31: {
    'status': 'Issue',
    'background': '#FAE1E1',
    'borderColor': '#F7CFCF',
    'color': '#C81313',
    'iconClassName': 'icon-infoalert',
    'className': 'issue no-link',
    'message': 'Your booking requires payment. Please urgently pay to avoid booking cancellation.',
    'link': 'nolink',
    'isIssue': true,
    'actionCTA': 'Pay for Booking'
  },
  32: {
    'status': 'Issue',
    'background': '#FAE1E1',
    'borderColor': '#F7CFCF',
    'color': '#C81313',
    'iconClassName': 'icon-infoalert',
    'className': 'issue',
    'message': 'Unfortunately your bags cannot be checked in. Someone from our team will contact you urgently to arrange the handover of your luggage. Learn more by clicking here.',
    'link': 'https://support.airportr.com/hc/en-us/articles/115000581085-My-bags-could-not-be-checked-in-where-do-I-meet-you-to-get-them-back',
    'isIssue': true,
    'actionCTA': 'Track'
  },
  40: {
    'status': 'Cancelled',
    'background': '#00005A0D',
    'borderColor': 'transparent',
    'color': '#00005A80',
    'iconClassName': '',
    'className': 'cancelled',
    'message': '',
    'link': '',
    'isIssue': false,
    'actionCTA': 'empty',
  },
  50: {
    'status': 'Completed',
    'background': '#D9F8DE',
    'borderColor': 'transparent',
    'color': 'transparent',
    'iconClassName': '',
    'className': 'completed',
    'message': '',
    'link': '',
    'isIssue': false,
    'actionCTA': 'Track'
  },
  51: {
    'status': 'Completed',
    'background': '#FAE1E1',
    'borderColor': '#F7CFCF',
    'color': '#C81313',
    'iconClassName': 'icon-alert',
    'className': 'completed-waring',
    'message': 'Please pay your excess charges to avoid booking cancellation. Learn more by clicking here.',
    'link': 'https://support.airportr.com/hc/en-us/articles/34693504311185-Understanding-Charges-and-Fees',
    'isIssue': true,
    'actionCTA': 'Pay Excess Charges'
  }
};


// tracking statuses & icons
export const TRACKING_STATUS = {
  outbound: [
    {
      status: 'Cancelled',
      icon: 'scan'
    },
    {
      status: 'Scheduled',
      icon: 'clock'
    },
    {
      status: 'Driver on the way',
      icon: 'truck_right'
    },
    {
      status: 'En route to service centre',
      icon: 'truck_left'
    },
    {
      status: 'At airport service centre',
      icon: 'business'
    },
    {
      status: 'At airport service centre',
      icon: 'business'
    },
    {
      status: 'Ready for collection',
      icon: 'palm_bag'
    },
    {
      status: 'Complete',
      icon: 'thumbs_up'
    },
    {
      status: 'At airport service centre',
      icon: 'business'
    }],
  inbound: [
    {
      status: 'Cancelled',
      icon: 'scan'
    },
    {
      status: 'Scheduled',
      icon: 'clock'
    },
    {
      status: 'Ready for drop off',
      icon: 'truck_right'
    },
    {
      status: 'En route to service centre',
      icon: 'truck_left'
    },
    {
      status: 'At airport service centre',
      icon: 'business'
    },
    {
      status: 'At airport service centre',
      icon: 'business'
    },
    {
      status: 'Driver on the way',
      icon: 'palm_bag'
    },
    {
      status: 'Complete',
      icon: 'thumbs_up'
    },
    {
      status: 'At airport service centre',
      icon: 'business'
    }],
  a2a: [
    {
      status: 'Cancelled',
      icon: 'scan'
    },
    {
      status: 'Scheduled',
      icon: 'clock'
    },
    {
      status: 'Ready for drop off',
      icon: 'truck_right'
    },
    {
      status: 'En route to service centre',
      icon: 'truck_left'
    },
    {
      status: 'At airport service centre',
      icon: 'business'
    },
    {
      status: 'At airport service centre',
      icon: 'business'
    },
    {
      status: 'Ready for collection',
      icon: 'palm_bag'
    },
    {
      status: 'Complete',
      icon: 'thumbs_up'
    },
    {
      status: 'At airport service centre',
      icon: 'business'
    }]
};


// bags
export const BAG_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25];


// for Apple Pay
export const APPLE_MERCHANT_COUNTRY_CODE = 'GB';

// country codes
export const COUNTRY_CODES = {
  featured: [],
  all: [
    {
      countryCodeName: 'DZ',
      countryCode: '213',
      displayText: 'Algeria (+213)',
      countryName: 'Algeria',
      label: 'Other countries'
    },
    {
      countryCodeName: 'AD',
      countryCode: '376',
      displayText: 'Andorra (+376)',
      countryName: 'Andorra',
      label: 'Other countries'
    },
    {
      countryCodeName: 'AO',
      countryCode: '244',
      displayText: 'Angola (+244)',
      countryName: 'Angola',
      label: 'Other countries'
    },
    {
      countryCodeName: 'AI',
      countryCode: '1264',
      displayText: 'Anguilla (+1264)',
      countryName: 'Anguilla',
      label: 'Other countries'
    },
    {
      countryCodeName: 'AG',
      countryCode: '1268',
      displayText: 'Antigua & Barbuda (+1268)',
      countryName: 'Antigua And Barbuda',
      label: 'Other countries'
    },
    {
      countryCodeName: 'AR',
      countryCode: '54',
      displayText: 'Argentina (+54)',
      countryName: 'Argentina',
      label: 'Other countries'
    },
    {
      countryCodeName: 'AM',
      countryCode: '374',
      displayText: 'Armenia (+374)',
      countryName: 'Armenia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'AW',
      countryCode: '297',
      displayText: 'Aruba (+297)',
      countryName: 'Aruba',
      label: 'Other countries'
    },
    {
      countryCodeName: 'AU',
      countryCode: '61',
      displayText: 'Australia (+61)',
      countryName: 'Australia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'AT',
      countryCode: '43',
      displayText: 'Austria (+43)',
      countryName: 'Austria',
      label: 'Other countries'
    },
    {
      countryCodeName: 'AZ',
      countryCode: '994',
      displayText: 'Azerbaijan (+994)',
      countryName: 'Azerbaijan',
      label: 'Other countries'
    },
    {
      countryCodeName: 'BS',
      countryCode: '1242',
      displayText: 'Bahamas (+1242)',
      countryName: 'Bahamas',
      label: 'Other countries'
    },
    {
      countryCodeName: 'BH',
      countryCode: '973',
      displayText: 'Bahrain (+973)',
      countryName: 'Bahrain',
      label: 'Other countries'
    },
    {
      countryCodeName: 'BD',
      countryCode: '880',
      displayText: 'Bangladesh (+880)',
      countryName: 'Bangladesh',
      label: 'Other countries'
    },
    {
      countryCodeName: 'BB',
      countryCode: '1246',
      displayText: 'Barbados (+1246)',
      countryName: 'Barbados',
      label: 'Other countries'
    },
    {
      countryCodeName: 'BY',
      countryCode: '375',
      displayText: 'Belarus (+375)',
      countryName: 'Belarus',
      label: 'Other countries'
    },
    {
      countryCodeName: 'BE',
      countryCode: '32',
      displayText: 'Belgium (+32)',
      countryName: 'Belgium',
      label: 'Other countries'
    },
    {
      countryCodeName: 'BZ',
      countryCode: '501',
      displayText: 'Belize (+501)',
      countryName: 'Belize',
      label: 'Other countries'
    },
    {
      countryCodeName: 'BJ',
      countryCode: '229',
      displayText: 'Benin (+229)',
      countryName: 'Benin',
      label: 'Other countries'
    },
    {
      countryCodeName: 'BM',
      countryCode: '1441',
      displayText: 'Bermuda (+1441)',
      countryName: 'Bermuda',
      label: 'Other countries'
    },
    {
      countryCodeName: 'BT',
      countryCode: '975',
      displayText: 'Bhutan (+975)',
      countryName: 'Bhutan',
      label: 'Other countries'
    },
    {
      countryCodeName: 'BO',
      countryCode: '591',
      displayText: 'Bolivia (+591)',
      countryName: 'Bolivia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'BA',
      countryCode: '387',
      displayText: 'Bosnia Herzegovina (+387)',
      countryName: 'Bosnia And Herzegovina',
      label: 'Other countries'
    },
    {
      countryCodeName: 'BW',
      countryCode: '267',
      displayText: 'Botswana (+267)',
      countryName: 'Botswana',
      label: 'Other countries'
    },
    {
      countryCodeName: 'BR',
      countryCode: '55',
      displayText: 'Brazil (+55)',
      countryName: 'Brazil',
      label: 'Other countries'
    },
    {
      countryCodeName: 'BN',
      countryCode: '673',
      displayText: 'Brunei (+673)',
      countryName: 'Brunei Darussalam',
      label: 'Other countries'
    },
    {
      countryCodeName: 'BG',
      countryCode: '359',
      displayText: 'Bulgaria (+359)',
      countryName: 'Bulgaria',
      label: 'Other countries'
    },
    {
      countryCodeName: 'BF',
      countryCode: '226',
      displayText: 'Burkina Faso (+226)',
      countryName: 'Burkina Faso',
      label: 'Other countries'
    },
    {
      countryCodeName: 'BI',
      countryCode: '257',
      displayText: 'Burundi (+257)',
      countryName: 'Burundi',
      label: 'Other countries'
    },
    {
      countryCodeName: 'KH',
      countryCode: '855',
      displayText: 'Cambodia (+855)',
      countryName: 'Cambodia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'CM',
      countryCode: '237',
      displayText: 'Cameroon (+237)',
      countryName: 'Cameroon',
      label: 'Other countries'
    },
    {
      countryCodeName: 'CA',
      countryCode: '1',
      displayText: 'Canada (+1)',
      countryName: 'Canada',
      label: 'Other countries'
    },
    {
      countryCodeName: 'CV',
      countryCode: '238',
      displayText: 'Cape Verde Islands (+238)',
      countryName: 'Cape Verde',
      label: 'Other countries'
    },
    {
      countryCodeName: 'KY',
      countryCode: '1345',
      displayText: 'Cayman Islands (+1345)',
      countryName: 'Cayman Islands',
      label: 'Other countries'
    },
    {
      countryCodeName: 'CF',
      countryCode: '236',
      displayText: 'Central African Republic (+236)',
      countryName: 'Central African Republic',
      label: 'Other countries'
    },
    {
      countryCodeName: 'CL',
      countryCode: '56',
      displayText: 'Chile (+56)',
      countryName: 'Chile',
      label: 'Other countries'
    },
    {
      countryCodeName: 'CN',
      countryCode: '86',
      displayText: 'China (+86)',
      countryName: 'China',
      label: 'Other countries'
    },
    {
      countryCodeName: 'CO',
      countryCode: '57',
      displayText: 'Colombia (+57)',
      countryName: 'Colombia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'KM',
      countryCode: '269',
      displayText: 'Comoros (+269)',
      countryName: 'Comoros',
      label: 'Other countries'
    },
    {
      countryCodeName: 'CG',
      countryCode: '242',
      displayText: 'Congo (+242)',
      countryName: 'Congo',
      label: 'Other countries'
    },
    {
      countryCodeName: 'CK',
      countryCode: '682',
      displayText: 'Cook Islands (+682)',
      countryName: 'Cook Islands',
      label: 'Other countries'
    },
    {
      countryCodeName: 'CR',
      countryCode: '506',
      displayText: 'Costa Rica (+506)',
      countryName: 'Costa Rica',
      label: 'Other countries'
    },
    {
      countryCodeName: 'HR',
      countryCode: '385',
      displayText: 'Croatia (+385)',
      countryName: 'Croatia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'CU',
      countryCode: '53',
      displayText: 'Cuba (+53)',
      countryName: 'Cuba',
      label: 'Other countries'
    },
    {
      countryCodeName: 'CY',
      countryCode: '90392',
      displayText: 'Cyprus North (+90392)',
      countryName: 'Cyprus',
      label: 'Other countries'
    },
    {
      countryCodeName: 'CY',
      countryCode: '357',
      displayText: 'Cyprus South (+357)',
      countryName: 'Cyprus',
      label: 'Other countries'
    },
    {
      countryCodeName: 'CZ',
      countryCode: '42',
      displayText: 'Czech Republic (+42)',
      countryName: 'Czech Republic',
      label: 'Other countries'
    },
    {
      countryCodeName: 'DK',
      countryCode: '45',
      displayText: 'Denmark (+45)',
      countryName: 'Denmark',
      label: 'Other countries'
    },
    {
      countryCodeName: 'DJ',
      countryCode: '253',
      displayText: 'Djibouti (+253)',
      countryName: 'Djibouti',
      label: 'Other countries'
    },
    {
      countryCodeName: 'DM',
      countryCode: '1809',
      displayText: 'Dominica (+1809)',
      countryName: 'Dominica',
      label: 'Other countries'
    },
    {
      countryCodeName: 'DO',
      countryCode: '1809',
      displayText: 'Dominican Republic (+1809)',
      countryName: 'Dominican Republic',
      label: 'Other countries'
    },
    {
      countryCodeName: 'EC',
      countryCode: '593',
      displayText: 'Ecuador (+593)',
      countryName: 'Ecuador',
      label: 'Other countries'
    },
    {
      countryCodeName: 'EG',
      countryCode: '20',
      displayText: 'Egypt (+20)',
      countryName: 'Egypt',
      label: 'Other countries'
    },
    {
      countryCodeName: 'SV',
      countryCode: '503',
      displayText: 'El Salvador (+503)',
      countryName: 'El Salvador',
      label: 'Other countries'
    },
    {
      countryCodeName: 'GQ',
      countryCode: '240',
      displayText: 'Equatorial Guinea (+240)',
      countryName: 'Equatorial Guinea',
      label: 'Other countries'
    },
    {
      countryCodeName: 'ER',
      countryCode: '291',
      displayText: 'Eritrea (+291)',
      countryName: 'Eritrea',
      label: 'Other countries'
    },
    {
      countryCodeName: 'EE',
      countryCode: '372',
      displayText: 'Estonia (+372)',
      countryName: 'Estonia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'ET',
      countryCode: '251',
      displayText: 'Ethiopia (+251)',
      countryName: 'Ethiopia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'FK',
      countryCode: '500',
      displayText: 'Falkland Islands (+500)',
      countryName: 'Falkland Islands (Malvinas)',
      label: 'Other countries'
    },
    {
      countryCodeName: 'FO',
      countryCode: '298',
      displayText: 'Faroe Islands (+298)',
      countryName: 'Faroe Islands',
      label: 'Other countries'
    },
    {
      countryCodeName: 'FJ',
      countryCode: '679',
      displayText: 'Fiji (+679)',
      countryName: 'Fiji',
      label: 'Other countries'
    },
    {
      countryCodeName: 'FI',
      countryCode: '358',
      displayText: 'Finland (+358)',
      countryName: 'Finland',
      label: 'Other countries'
    },
    {
      countryCodeName: 'FR',
      countryCode: '33',
      displayText: 'France (+33)',
      countryName: 'France',
      label: 'Other countries'
    },
    {
      countryCodeName: 'GF',
      countryCode: '594',
      displayText: 'French Guiana (+594)',
      countryName: 'French Guiana',
      label: 'Other countries'
    },
    {
      countryCodeName: 'PF',
      countryCode: '689',
      displayText: 'French Polynesia (+689)',
      countryName: 'French Polynesia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'GA',
      countryCode: '241',
      displayText: 'Gabon (+241)',
      countryName: 'Gabon',
      label: 'Other countries'
    },
    {
      countryCodeName: 'GM',
      countryCode: '220',
      displayText: 'Gambia (+220)',
      countryName: 'Gambia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'GE',
      countryCode: '7880',
      displayText: 'Georgia (+7880)',
      countryName: 'Georgia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'DE',
      countryCode: '49',
      displayText: 'Germany (+49)',
      countryName: 'Germany',
      label: 'Other countries'
    },
    {
      countryCodeName: 'GH',
      countryCode: '233',
      displayText: 'Ghana (+233)',
      countryName: 'Ghana',
      label: 'Other countries'
    },
    {
      countryCodeName: 'GI',
      countryCode: '350',
      displayText: 'Gibraltar (+350)',
      countryName: 'Gibraltar',
      label: 'Other countries'
    },
    {
      countryCodeName: 'GR',
      countryCode: '30',
      displayText: 'Greece (+30)',
      countryName: 'Greece',
      label: 'Other countries'
    },
    {
      countryCodeName: 'GL',
      countryCode: '299',
      displayText: 'Greenland (+299)',
      countryName: 'Greenland',
      label: 'Other countries'
    },
    {
      countryCodeName: 'GD',
      countryCode: '1473',
      displayText: 'Grenada (+1473)',
      countryName: 'Grenada',
      label: 'Other countries'
    },
    {
      countryCodeName: 'GP',
      countryCode: '590',
      displayText: 'Guadeloupe (+590)',
      countryName: 'Guadeloupe',
      label: 'Other countries'
    },
    {
      countryCodeName: 'GU',
      countryCode: '671',
      displayText: 'Guam (+671)',
      countryName: 'Guam',
      label: 'Other countries'
    },
    {
      countryCodeName: 'GT',
      countryCode: '502',
      displayText: 'Guatemala (+502)',
      countryName: 'Guatemala',
      label: 'Other countries'
    },
    {
      countryCodeName: 'GN',
      countryCode: '224',
      displayText: 'Guinea (+224)',
      countryName: 'Guinea',
      label: 'Other countries'
    },
    {
      countryCodeName: 'GW',
      countryCode: '245',
      displayText: 'Guinea - Bissau (+245)',
      countryName: 'Guinea-Bissau',
      label: 'Other countries'
    },
    {
      countryCodeName: 'GY',
      countryCode: '592',
      displayText: 'Guyana (+592)',
      countryName: 'Guyana',
      label: 'Other countries'
    },
    {
      countryCodeName: 'HT',
      countryCode: '509',
      displayText: 'Haiti (+509)',
      countryName: 'Haiti',
      label: 'Other countries'
    },
    {
      countryCodeName: 'HN',
      countryCode: '504',
      displayText: 'Honduras (+504)',
      countryName: 'Honduras',
      label: 'Other countries'
    },
    {
      countryCodeName: 'HK',
      countryCode: '852',
      displayText: 'Hong Kong (+852)',
      countryName: 'Hong Kong',
      label: 'Other countries'
    },
    {
      countryCodeName: 'HU',
      countryCode: '36',
      displayText: 'Hungary (+36)',
      countryName: 'Hungary',
      label: 'Other countries'
    },
    {
      countryCodeName: 'IS',
      countryCode: '354',
      displayText: 'Iceland (+354)',
      countryName: 'Iceland',
      label: 'Other countries'
    },
    {
      countryCodeName: 'IN',
      countryCode: '91',
      displayText: 'India (+91)',
      countryName: 'India',
      label: 'Other countries'
    },
    {
      countryCodeName: 'ID',
      countryCode: '62',
      displayText: 'Indonesia (+62)',
      countryName: 'Indonesia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'IR',
      countryCode: '98',
      displayText: 'Iran (+98)',
      countryName: 'Iran, Islamic Republic Of',
      label: 'Other countries'
    },
    {
      countryCodeName: 'IQ',
      countryCode: '964',
      displayText: 'Iraq (+964)',
      countryName: 'Iraq',
      label: 'Other countries'
    },
    {
      countryCodeName: 'IE',
      countryCode: '353',
      displayText: 'Ireland (+353)',
      countryName: 'Ireland',
      label: 'Other countries'
    },
    {
      countryCodeName: 'IL',
      countryCode: '972',
      displayText: 'Israel (+972)',
      countryName: 'Israel',
      label: 'Other countries'
    },
    {
      countryCodeName: 'IT',
      countryCode: '39',
      displayText: 'Italy (+39)',
      countryName: 'Italy',
      label: 'Other countries'
    },
    {
      countryCodeName: 'JM',
      countryCode: '1876',
      displayText: 'Jamaica (+1876)',
      countryName: 'Jamaica',
      label: 'Other countries'
    },
    {
      countryCodeName: 'JP',
      countryCode: '81',
      displayText: 'Japan (+81)',
      countryName: 'Japan',
      label: 'Other countries'
    },
    {
      countryCodeName: 'JO',
      countryCode: '962',
      displayText: 'Jordan (+962)',
      countryName: 'Jordan',
      label: 'Other countries'
    },
    {
      countryCodeName: 'KZ',
      countryCode: '7',
      displayText: 'Kazakhstan (+7)',
      countryName: 'Kazakhstan',
      label: 'Other countries'
    },
    {
      countryCodeName: 'KE',
      countryCode: '254',
      displayText: 'Kenya (+254)',
      countryName: 'Kenya',
      label: 'Other countries'
    },
    {
      countryCodeName: 'KI',
      countryCode: '686',
      displayText: 'Kiribati (+686)',
      countryName: 'Kiribati',
      label: 'Other countries'
    },
    {
      countryCodeName: 'KP',
      countryCode: '850',
      displayText: 'Korea North (+850)',
      countryName: 'Democratic People\'s Republic of Korea',
      label: 'Other countries'
    },
    {
      countryCodeName: 'KR',
      countryCode: '82',
      displayText: 'Korea South (+82)',
      countryName: 'Korea',
      label: 'Other countries'
    },
    {
      countryCodeName: 'KW',
      countryCode: '965',
      displayText: 'Kuwait (+965)',
      countryName: 'Kuwait',
      label: 'Other countries'
    },
    {
      countryCodeName: 'KG',
      countryCode: '996',
      displayText: 'Kyrgyzstan (+996)',
      countryName: 'Kyrgyzstan',
      label: 'Other countries'
    },
    {
      countryCodeName: 'LA',
      countryCode: '856',
      displayText: 'Laos (+856)',
      countryName: 'Lao People\'s Democratic Republic',
      label: 'Other countries'
    },
    {
      countryCodeName: 'LV',
      countryCode: '371',
      displayText: 'Latvia (+371)',
      countryName: 'Latvia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'LB',
      countryCode: '961',
      displayText: 'Lebanon (+961)',
      countryName: 'Lebanon',
      label: 'Other countries'
    },
    {
      countryCodeName: 'LS',
      countryCode: '266',
      displayText: 'Lesotho (+266)',
      countryName: 'Lesotho',
      label: 'Other countries'
    },
    {
      countryCodeName: 'LR',
      countryCode: '231',
      displayText: 'Liberia (+231)',
      countryName: 'Liberia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'LY',
      countryCode: '218',
      displayText: 'Libya (+218)',
      countryName: 'Libyan Arab Jamahiriya',
      label: 'Other countries'
    },
    {
      countryCodeName: 'LI',
      countryCode: '423',
      displayText: 'Liechtenstein (+423)',
      countryName: 'Liechtenstein',
      label: 'Other countries'
    },
    {
      countryCodeName: 'LT',
      countryCode: '370',
      displayText: 'Lithuania (+370)',
      countryName: 'Lithuania',
      label: 'Other countries'
    },
    {
      countryCodeName: 'LU',
      countryCode: '352',
      displayText: 'Luxembourg (+352)',
      countryName: 'Luxembourg',
      label: 'Other countries'
    },
    {
      countryCodeName: 'MO',
      countryCode: '853',
      displayText: 'Macao (+853)',
      countryName: 'Macao',
      label: 'Other countries'
    },
    {
      countryCodeName: 'MK',
      countryCode: '389',
      displayText: 'Macedonia (+389)',
      countryName: 'Macedonia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'MG',
      countryCode: '261',
      displayText: 'Madagascar (+261)',
      countryName: 'Madagascar',
      label: 'Other countries'
    },
    {
      countryCodeName: 'MW',
      countryCode: '265',
      displayText: 'Malawi (+265)',
      countryName: 'Malawi',
      label: 'Other countries'
    },
    {
      countryCodeName: 'MY',
      countryCode: '60',
      displayText: 'Malaysia (+60)',
      countryName: 'Malaysia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'MV',
      countryCode: '960',
      displayText: 'Maldives (+960)',
      countryName: 'Maldives',
      label: 'Other countries'
    },
    {
      countryCodeName: 'ML',
      countryCode: '223',
      displayText: 'Mali (+223)',
      countryName: 'Mali',
      label: 'Other countries'
    },
    {
      countryCodeName: 'MT',
      countryCode: '356',
      displayText: 'Malta (+356)',
      countryName: 'Malta',
      label: 'Other countries'
    },
    {
      countryCodeName: 'MH',
      countryCode: '692',
      displayText: 'Marshall Islands (+692)',
      countryName: 'Marshall Islands',
      label: 'Other countries'
    },
    {
      countryCodeName: 'MQ',
      countryCode: '596',
      displayText: 'Martinique (+596)',
      countryName: 'Martinique',
      label: 'Other countries'
    },
    {
      countryCodeName: 'MR',
      countryCode: '222',
      displayText: 'Mauritania (+222)',
      countryName: 'Mauritania',
      label: 'Other countries'
    },
    {
      countryCodeName: 'YT',
      countryCode: '269',
      displayText: 'Mayotte (+269)',
      countryName: 'Mayotte',
      label: 'Other countries'
    },
    {
      countryCodeName: 'MX',
      countryCode: '52',
      displayText: 'Mexico (+52)',
      countryName: 'Mexico',
      label: 'Other countries'
    },
    {
      countryCodeName: 'FM',
      countryCode: '691',
      displayText: 'Micronesia (+691)',
      countryName: 'Micronesia, Federated States Of',
      label: 'Other countries'
    },
    {
      countryCodeName: 'MD',
      countryCode: '373',
      displayText: 'Moldova (+373)',
      countryName: 'Moldova',
      label: 'Other countries'
    },
    {
      countryCodeName: 'MC',
      countryCode: '377',
      displayText: 'Monaco (+377)',
      countryName: 'Monaco',
      label: 'Other countries'
    },
    {
      countryCodeName: 'MN',
      countryCode: '976',
      displayText: 'Mongolia (+976)',
      countryName: 'Mongolia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'MS',
      countryCode: '1664',
      displayText: 'Montserrat (+1664)',
      countryName: 'Montserrat',
      label: 'Other countries'
    },
    {
      countryCodeName: 'MA',
      countryCode: '212',
      displayText: 'Morocco (+212)',
      countryName: 'Morocco',
      label: 'Other countries'
    },
    {
      countryCodeName: 'MZ',
      countryCode: '258',
      displayText: 'Mozambique (+258)',
      countryName: 'Mozambique',
      label: 'Other countries'
    },
    {
      countryCodeName: 'MN',
      countryCode: '95',
      displayText: 'Myanmar (+95)',
      countryName: 'Mongolia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'NA',
      countryCode: '264',
      displayText: 'Namibia (+264)',
      countryName: 'Namibia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'NR',
      countryCode: '674',
      displayText: 'Nauru (+674)',
      countryName: 'Nauru',
      label: 'Other countries'
    },
    {
      countryCodeName: 'NP',
      countryCode: '977',
      displayText: 'Nepal (+977)',
      countryName: 'Nepal',
      label: 'Other countries'
    },
    {
      countryCodeName: 'NL',
      countryCode: '31',
      displayText: 'Netherlands (+31)',
      countryName: 'Netherlands',
      label: 'Other countries'
    },
    {
      countryCodeName: 'NC',
      countryCode: '687',
      displayText: 'New Caledonia (+687)',
      countryName: 'New Caledonia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'NZ',
      countryCode: '64',
      displayText: 'New Zealand (+64)',
      countryName: 'New Zealand',
      label: 'Other countries'
    },
    {
      countryCodeName: 'NI',
      countryCode: '505',
      displayText: 'Nicaragua (+505)',
      countryName: 'Nicaragua',
      label: 'Other countries'
    },
    {
      countryCodeName: 'NE',
      countryCode: '227',
      displayText: 'Niger (+227)',
      countryName: 'Niger',
      label: 'Other countries'
    },
    {
      countryCodeName: 'NG',
      countryCode: '234',
      displayText: 'Nigeria (+234)',
      countryName: 'Nigeria',
      label: 'Other countries'
    },
    {
      countryCodeName: 'NU',
      countryCode: '683',
      displayText: 'Niue (+683)',
      countryName: 'Niue',
      label: 'Other countries'
    },
    {
      countryCodeName: 'NF',
      countryCode: '672',
      displayText: 'Norfolk Islands (+672)',
      countryName: 'Norfolk Island',
      label: 'Other countries'
    },
    {
      countryCodeName: 'NP',
      countryCode: '670',
      displayText: 'Northern Marianas (+670)',
      countryName: 'Nepal',
      label: 'Other countries'
    },
    {
      countryCodeName: 'NO',
      countryCode: '47',
      displayText: 'Norway (+47)',
      countryName: 'Norway',
      label: 'Other countries'
    },
    {
      countryCodeName: 'OM',
      countryCode: '968',
      displayText: 'Oman (+968)',
      countryName: 'Oman',
      label: 'Other countries'
    },
    {
      countryCodeName: 'PW',
      countryCode: '92',
      displayText: 'Pakistan (+92)',
      countryName: 'Pakistan',
      label: 'Other countries'
    },
    {
      countryCodeName: 'PW',
      countryCode: '680',
      displayText: 'Palau (+680)',
      countryName: 'Palau',
      label: 'Other countries'
    },
    {
      countryCodeName: 'PA',
      countryCode: '507',
      displayText: 'Panama (+507)',
      countryName: 'Panama',
      label: 'Other countries'
    },
    {
      countryCodeName: 'PG',
      countryCode: '675',
      displayText: 'Papua New Guinea (+675)',
      countryName: 'Papua New Guinea',
      label: 'Other countries'
    },
    {
      countryCodeName: 'PY',
      countryCode: '595',
      displayText: 'Paraguay (+595)',
      countryName: 'Paraguay',
      label: 'Other countries'
    },
    {
      countryCodeName: 'PE',
      countryCode: '51',
      displayText: 'Peru (+51)',
      countryName: 'Peru',
      label: 'Other countries'
    },
    {
      countryCodeName: 'PH',
      countryCode: '63',
      displayText: 'Philippines (+63)',
      countryName: 'Philippines',
      label: 'Other countries'
    },
    {
      countryCodeName: 'PL',
      countryCode: '48',
      displayText: 'Poland (+48)',
      countryName: 'Poland',
      label: 'Other countries'
    },
    {
      countryCodeName: 'PT',
      countryCode: '351',
      displayText: 'Portugal (+351)',
      countryName: 'Portugal',
      label: 'Other countries'
    },
    {
      countryCodeName: 'PR',
      countryCode: '1787',
      displayText: 'Puerto Rico (+1787)',
      countryName: 'Puerto Rico',
      label: 'Other countries'
    },
    {
      countryCodeName: 'QA',
      countryCode: '974',
      displayText: 'Qatar (+974)',
      countryName: 'Qatar',
      label: 'Other countries'
    },
    {
      countryCodeName: 'RE',
      countryCode: '262',
      displayText: 'Reunion (+262)',
      countryName: 'Reunion',
      label: 'Other countries'
    },
    {
      countryCodeName: 'RO',
      countryCode: '40',
      displayText: 'Romania (+40)',
      countryName: 'Romania',
      label: 'Other countries'
    },
    {
      countryCodeName: 'RU',
      countryCode: '7',
      displayText: 'Russia (+7)',
      countryName: 'Russian Federation',
      label: 'Other countries'
    },
    {
      countryCodeName: 'RW',
      countryCode: '250',
      displayText: 'Rwanda (+250)',
      countryName: 'Rwanda',
      label: 'Other countries'
    },
    {
      countryCodeName: 'SM',
      countryCode: '378',
      displayText: 'San Marino (+378)',
      countryName: 'San Marino',
      label: 'Other countries'
    },
    {
      countryCodeName: 'ST',
      countryCode: '239',
      displayText: 'Sao Tome & Principe (+239)',
      countryName: 'Sao Tome And Principe',
      label: 'Other countries'
    },
    {
      countryCodeName: 'SA',
      countryCode: '966',
      displayText: 'Saudi Arabia (+966)',
      countryName: 'Saudi Arabia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'SN',
      countryCode: '221',
      displayText: 'Senegal (+221)',
      countryName: 'Senegal',
      label: 'Other countries'
    },
    {
      countryCodeName: 'RS',
      countryCode: '381',
      displayText: 'Serbia (+381)',
      countryName: 'Serbia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'SC',
      countryCode: '248',
      displayText: 'Seychelles (+248)',
      countryName: 'Seychelles',
      label: 'Other countries'
    },
    {
      countryCodeName: 'SL',
      countryCode: '232',
      displayText: 'Sierra Leone (+232)',
      countryName: 'Sierra Leone',
      label: 'Other countries'
    },
    {
      countryCodeName: 'SG',
      countryCode: '65',
      displayText: 'Singapore (+65)',
      countryName: 'Singapore',
      label: 'Other countries'
    },
    {
      countryCodeName: 'SK',
      countryCode: '421',
      displayText: 'Slovak Republic (+421)',
      countryName: 'Slovakia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'SI',
      countryCode: '386',
      displayText: 'Slovenia (+386)',
      countryName: 'Slovenia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'SB',
      countryCode: '677',
      displayText: 'Solomon Islands (+677)',
      countryName: 'Solomon Islands',
      label: 'Other countries'
    },
    {
      countryCodeName: 'SO',
      countryCode: '252',
      displayText: 'Somalia (+252)',
      countryName: 'Somalia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'ZA',
      countryCode: '27',
      displayText: 'South Africa (+27)',
      countryName: 'South Africa',
      label: 'Other countries'
    },
    {
      countryCodeName: 'ES',
      countryCode: '34',
      displayText: 'Spain (+34)',
      countryName: 'Spain',
      label: 'Other countries'
    },
    {
      countryCodeName: 'LK',
      countryCode: '94',
      displayText: 'Sri Lanka (+94)',
      countryName: 'Sri Lanka',
      label: 'Other countries'
    },
    {
      countryCodeName: 'SH',
      countryCode: '290',
      displayText: 'St. Helena (+290)',
      countryName: 'Saint Helena',
      label: 'Other countries'
    },
    {
      countryCodeName: 'KN',
      countryCode: '1869',
      displayText: 'St. Kitts (+1869)',
      countryName: 'Saint Kitts And Nevis',
      label: 'Other countries'
    },
    {
      countryCodeName: 'SC',
      countryCode: '1758',
      displayText: 'St. Lucia (+1758)',
      countryName: 'Seychelles',
      label: 'Other countries'
    },
    {
      countryCodeName: 'SD',
      countryCode: '249',
      displayText: 'Sudan (+249)',
      countryName: 'Sudan',
      label: 'Other countries'
    },
    {
      countryCodeName: 'SR',
      countryCode: '597',
      displayText: 'Suriname (+597)',
      countryName: 'Suriname',
      label: 'Other countries'
    },
    {
      countryCodeName: 'SZ',
      countryCode: '268',
      displayText: 'Swaziland (+268)',
      countryName: 'Swaziland',
      label: 'Other countries'
    },
    {
      countryCodeName: 'SE',
      countryCode: '46',
      displayText: 'Sweden (+46)',
      countryName: 'Sweden',
      label: 'Other countries'
    },
    {
      countryCodeName: 'CH',
      countryCode: '41',
      displayText: 'Switzerland (+41)',
      countryName: 'Switzerland',
      label: 'Other countries'
    },
    {
      countryCodeName: 'SI',
      countryCode: '963',
      displayText: 'Syria (+963)',
      countryName: 'Slovenia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'TW',
      countryCode: '886',
      displayText: 'Taiwan (+886)',
      countryName: 'Taiwan',
      label: 'Other countries'
    },
    {
      countryCodeName: 'TJ',
      countryCode: '7',
      displayText: 'Tajikstan (+7)',
      countryName: 'Tajikistan',
      label: 'Other countries'
    },
    {
      countryCodeName: 'TH',
      countryCode: '66',
      displayText: 'Thailand (+66)',
      countryName: 'Thailand',
      label: 'Other countries'
    },
    {
      countryCodeName: 'TG',
      countryCode: '228',
      displayText: 'Togo (+228)',
      countryName: 'Togo',
      label: 'Other countries'
    },
    {
      countryCodeName: 'TO',
      countryCode: '676',
      displayText: 'Tonga (+676)',
      countryName: 'Tonga',
      label: 'Other countries'
    },
    {
      countryCodeName: 'TT',
      countryCode: '1868',
      displayText: 'Trinidad & Tobago (+1868)',
      countryName: 'Trinidad And Tobago',
      label: 'Other countries'
    },
    {
      countryCodeName: 'TN',
      countryCode: '216',
      displayText: 'Tunisia (+216)',
      countryName: 'Tunisia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'TR',
      countryCode: '90',
      displayText: 'Turkey (+90)',
      countryName: 'Turkey',
      label: 'Other countries'
    },
    {
      countryCodeName: 'TM',
      countryCode: '993',
      displayText: 'Turkmenistan (+993)',
      countryName: 'Turkmenistan',
      label: 'Other countries'
    },
    {
      countryCodeName: 'TC',
      countryCode: '1649',
      displayText: 'Turks & Caicos Islands (+1649)',
      countryName: 'Turks And Caicos Islands',
      label: 'Other countries'
    },
    {
      countryCodeName: 'TV',
      countryCode: '688',
      displayText: 'Tuvalu (+688)',
      countryName: 'Tuvalu',
      label: 'Other countries'
    },
    {
      countryCodeName: 'UG',
      countryCode: '256',
      displayText: 'Uganda (+256)',
      countryName: 'Uganda',
      label: 'Other countries'
    },
    {
      countryCodeName: 'UA',
      countryCode: '380',
      displayText: 'Ukraine (+380)',
      countryName: 'Ukraine',
      label: 'Other countries'
    },
    {
      countryCodeName: 'AE',
      countryCode: '971',
      displayText: 'United Arab Emirates (+971)',
      countryName: 'United Arab Emirates',
      label: 'Other countries'
    },
    {
      countryCodeName: 'GB',
      countryCode: '44',
      displayText: 'UK (+44)',
      countryName: 'United Kingdom',
      label: 'Other countries'
    },
    {
      countryCodeName: 'US',
      countryCode: '1',
      displayText: 'USA (+1)',
      countryName: 'United States',
      label: 'Other countries'
    },
    {
      countryCodeName: 'UY',
      countryCode: '598',
      displayText: 'Uruguay (+598)',
      countryName: 'Uruguay',
      label: 'Other countries'
    },
    {
      countryCodeName: 'UZ',
      countryCode: '998',
      displayText: 'Uzbekistan (+998)',
      countryName: 'Uzbekistan',
      label: 'Other countries'
    },
    {
      countryCodeName: 'VU',
      countryCode: '678',
      displayText: 'Vanuatu (+678)',
      countryName: 'Vanuatu',
      label: 'Other countries'
    },
    {
      countryCodeName: 'VA',
      countryCode: '379',
      displayText: 'Vatican City (+379)',
      countryName: 'Holy See (Vatican City State)',
      label: 'Other countries'
    },
    {
      countryCodeName: 'VE',
      countryCode: '58',
      displayText: 'Venezuela (+58)',
      countryName: 'Venezuela',
      label: 'Other countries'
    },
    {
      countryCodeName: 'VN',
      countryCode: '84',
      displayText: 'Vietnam (+84)',
      countryName: 'Viet Nam',
      label: 'Other countries'
    },
    {
      countryCodeName: 'VG',
      countryCode: '1284',
      displayText: 'Virgin Islands - British (+1284)',
      countryName: 'Virgin Islands, British',
      label: 'Other countries'
    },
    {
      countryCodeName: 'VI',
      countryCode: '1340',
      displayText: 'Virgin Islands - US (+1340)',
      countryName: 'Virgin Islands, U.S.',
      label: 'Other countries'
    },
    {
      countryCodeName: 'WF',
      countryCode: '681',
      displayText: 'Wallis & Futuna (+681)',
      countryName: 'Wallis And Futuna',
      label: 'Other countries'
    },
    {
      countryCodeName: 'YE',
      countryCode: '969',
      displayText: 'Yemen (North)(+969)',
      countryName: 'Yemen North',
      label: 'Other countries'
    },
    {
      countryCodeName: 'YE',
      countryCode: '967',
      displayText: 'Yemen (South)(+967)',
      countryName: 'Yemen South',
      label: 'Other countries'
    },
    {
      countryCodeName: 'ZM',
      countryCode: '260',
      displayText: 'Zambia (+260)',
      countryName: 'Zambia',
      label: 'Other countries'
    },
    {
      countryCodeName: 'ZW',
      countryCode: '263',
      displayText: 'Zimbabwe (+263)',
      countryName: 'Zimbabwe',
      label: 'Other countries'
    }
  ]
};

export const AGM_MAP_STYLE = [
  {
    'featureType': 'administrative',
    'elementType': 'labels',
    'stylers': [
      {
        'visibility': 'simplified'
      },
      {
        'lightness': '35'
      }
    ]
  },
  {
    'featureType': 'landscape',
    'elementType': 'all',
    'stylers': [
      {
        'color': '#ffffff'
      }
    ]
  },
  {
    'featureType': 'poi',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  },
  {
    'featureType': 'road',
    'elementType': 'all',
    'stylers': [
      {
        'saturation': -100
      },
      {
        'lightness': 45
      },
      {
        'visibility': 'simplified'
      }
    ]
  },
  {
    'featureType': 'road',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#ebf0ff'
      }
    ]
  },
  {
    'featureType': 'road',
    'elementType': 'labels.text',
    'stylers': [
      {
        'visibility': 'simplified'
      },
      {
        'color': '#999bd3'
      }
    ]
  },
  {
    'featureType': 'road.highway',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'simplified'
      }
    ]
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#d4ddf6'
      }
    ]
  },
  {
    'featureType': 'road.highway',
    'elementType': 'labels',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  },
  {
    'featureType': 'road.arterial',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  },
  {
    'featureType': 'transit',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  },
  {
    'featureType': 'water',
    'elementType': 'all',
    'stylers': [
      {
        'color': '#97c4ff'
      },
      {
        'visibility': 'on'
      }
    ]
  }
];

export const CRM_POPUP_CONTENT = {
  exitNew: {
    layout: 'Exit-New',
    zapierEmailVariant: 'popup1',
    gaAction: 'Exit-funnel-new',
    subscribePanel: {
      title: 'Not ready to book yet?',
      subtitle: 'Leave us your email and we\'ll keep in touch, including a reminder before your next flight.',
      ctaLabel: 'Done',
      closeBtnLabel: 'I don\'t want to be reminded',
      imgDesktopURL: 'https://portrlivecdnstorage.blob.core.windows.net/assets/images/crm_subscribe_exit_new.jpg?sp=r&st=2023-07-31T13:28:56Z&se=2028-01-08T22:28:56Z&spr=https&sv=2022-11-02&sr=c&sig=Kd1nL6EpQREvU2OVv8Znrpx0iNVvzJNgGsI%2Big%2Bixo0%3D'
    },
    discountPanel: {
      title: 'Book today for 15% off',
      subtitle: 'Enjoy a discount if you complete your booking today',
      promoCode: 'AP2019P',
      ctaLabel: 'Great',
      closeBtnLabel: 'I\'ll use the discount later',
      imgDesktopURL: 'https://portrlivecdnstorage.blob.core.windows.net/assets/images/crm_subscribe_exit_new.jpg?sp=r&st=2023-07-31T13:28:56Z&se=2028-01-08T22:28:56Z&spr=https&sv=2022-11-02&sr=c&sig=Kd1nL6EpQREvU2OVv8Znrpx0iNVvzJNgGsI%2Big%2Bixo0%3D'
    }
  }
};

// Mobile breakpoint
export const MOBILE_MAX_WIDTH = 480;

export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

